import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { IconChevronUp, IconChevronDown } from 'components/Icons';

const PanelContainer = React.createClass({
    propTypes: {
        children: PropTypes.node
    },
    getInitialState: function() {
        return {
            isOpen: (
                window.matchMedia &&
                window.matchMedia('(max-width: 30em)').matches
            ) ? false : true
        };
    },
    handleToggle: function() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    },
    renderToggleButton() {
        const isOpen = this.state.isOpen;
        return (
            <button className={classnames({
                'u-syos-button-reset': true,
                'syos-panel-toggle': true,
                'syos-panel-toggle--show': !isOpen
            })} onClick={this.handleToggle}>
                {isOpen ? 'Hide controls' : 'Show controls'}
                {isOpen ? <IconChevronUp /> : <IconChevronDown />}
            </button>
        )
    },
    render: function() {
        const isOpen = this.state.isOpen;
        return (
            <div className={classnames({
                'syos-panel': true,
                'syos-panel--open': isOpen
            })}>
                {this.renderToggleButton()}
                <div className="syos-panel__inner">
                    {React.Children.map(this.props.children, function(child) {
                        return (child.props.isAvailable) ? (
                            <div className={classnames({
                                'syos-panel__segment': true,
                                'syos-panel__segment--available': child.props.isAvailable
                            })}>{child}</div>
                        ) : null;
                    })}
                </div>
            </div>
        );
    }
});

export default PanelContainer;



// WEBPACK FOOTER //
// ./src/javascripts/app/containers/PanelContainer.js